import { format } from 'owa-localize';
import attemptToSubmitAddEntityFeedback from './attemptToSubmitAddEntityFeedback';
import createEntityFeedbackEntry from './createEntityFeedbackEntry';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';
import EntityFeedbackEntry from 'owa-service/lib/contract/EntityFeedbackEntry';
import { action } from 'satcheljs/lib/legacy';
import { FeedbackManagerState } from 'owa-feedback-manager-store/lib/store/schema/FeedbackManagerState';

import { isNullOrWhiteSpace } from 'owa-string-utils';
import { trace } from 'owa-trace';

/**
 * Logs 'transaction complete' the specified feedbackManagerState
 * @param feedbackManagerState: the feedback manager state
 */
export default action('transactionComplete')(function transactionComplete(
    feedbackManagerState: FeedbackManagerState,
    queryString: string,
    locationsIdentifiers: string[],
    transactionId: string,
    relevanceHints: string[],
    requiredAttendees: string[] = null,
    optionalAttendees: string[] = null
) {
    if (feedbackManagerState) {
        if (feedbackManagerState.hasSessionStarted) {
            let jsonPropertyBagDictionary = {
                QueryString: queryString ? queryString : '',
                QueryStringLength: isNullOrWhiteSpace(queryString) ? 0 : queryString.length,
                ScenarioName: feedbackManagerState.entityScenarioName,
                RelevanceHints: JSON.stringify(relevanceHints),
                RequiredAttendees: JSON.stringify(requiredAttendees),
                OptionalAttendees: JSON.stringify(optionalAttendees),
            };
            let jsonPropertyBag = JSON.stringify(jsonPropertyBagDictionary);
            let targetList = JSON.stringify(locationsIdentifiers);

            let entry: EntityFeedbackEntry = createEntityFeedbackEntry(
                feedbackManagerState,
                transactionId,
                'TransactionCompleted',
                targetList,
                EntityAddSource.None,
                jsonPropertyBag
            );

            attemptToSubmitAddEntityFeedback(feedbackManagerState, entry, false);
            trace.info(
                format(
                    '{0} CompleteTransaction. Session id: {1}',
                    feedbackManagerState.entityScenarioName,
                    feedbackManagerState.clientSessionId
                )
            );
        }
    }
});
